var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProductCategoryIconVenue = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.956 10.507c5.268.13 9.786 1.969 13.552 5.515l-1.273 2.39C31.47 19.695 33.06 20.87 34 21.936l-3.19 8.467H18.997V26.03h-4.002v4.373H2.682L0 21.936c2.477-2.421 4.956-3.614 4.956-3.614l-1.389-2.3c3.657-3.808 8.12-5.646 13.389-5.515zm0 7.35c-5.576 0-10.334 1.607-14.274 4.82l1.87 5.353h8.043v-4.398h8.797v4.398h7.785l2.115-5.309.015-.04c-1.419-1.078-5.987-4.824-14.351-4.824zm9.748 3.742 2.119 1.127-1.127 2.12-2.119-1.128 1.127-2.119zm-19.008 0 1.127 2.12-2.12 1.126-1.126-2.119 2.12-1.127zm13.63-1.831 2.329.58-.581 2.329-2.329-.58.581-2.33zm-8.747 0 .58 2.328-2.328.58-.581-2.328 2.329-.58zm5.321-.246v2.4h-2.4v-2.4h2.4zm-.9-6.556c-4.052 0-7.507 1.166-10.366 3.499l.449.736c2.743-1.15 6.054-1.724 9.932-1.724s7.25.642 10.113 1.928l.394-.856c-2.963-2.389-6.47-3.583-10.522-3.583zM2.914 7.186l2.463 3.151-1.891 1.478-2.463-3.152 1.891-1.478zm28.852.051 1.697 1.697-2.829 2.829-1.697-1.697 2.829-2.829zM17.8 3.5v4h-2.4v-4h2.4z",
    fill: "#D23778",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProductCategoryIconVenue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/product-category-icon-venue.fddb4e6959cebb0f707c141a08e407a7.svg";